import React, { useState, useEffect } from 'react';
import { block } from 'bem-cn';

import SVG from 'components/SVG';
import Input from 'components/Input';

import loadingSVG from './img/loading.svg';

import './SearchUserInput.scss';

const b = block('search-user-input');

const SearchUserInput = ({
  filterValue,
  onButtonClick = () => {},
  handleSearchChange,
  placeholder,
  locale,
  isLoadingSearchResult,
  searchResult,
  handleResultClick,
}) => {
  const [isSelectedItem, setIsSelectedItem] = useState(false);

  const resultsItems = searchResult?.map(username => (
    <div
      key={username}
      className={b('result-item')}
      onClick={() => {
        handleResultClick(username);
        setIsSelectedItem(false);
      }}>
      {username}
    </div>
  ));

  const handleInput = e => {
    handleSearchChange(e);
    setIsSelectedItem(true);
  };

  return (
    <div className={b()}>
      <div className={b('input')}>
        <Input
          value={filterValue}
          callBack={handleInput}
          placeholder={placeholder ?? `${locale.search} ${locale.user}`}
        />
      </div>
      {resultsItems.length > 0 ? (
        <div className={b('search-results')}>{resultsItems}</div>
      ) : isLoadingSearchResult && searchResult.length === 0 ? (
        <div className={b('search-results')}>
          <div className={b('loading-block')}>
            <SVG svgProps={{ svg: loadingSVG }} className={b('loading-icon')} />
            <p>We are looking for..</p>
          </div>
        </div>
      ) : (
        isSelectedItem &&
        filterValue &&
        filterValue.length >= 4 &&
        searchResult.length <= 0 && (
          <div className={b('search-results')}>
            <span className={b('empty-text')}>Empty</span>
          </div>
        )
      )}
    </div>
  );
};

export default SearchUserInput;
